import { render, staticRenderFns } from "./AccountBookForm.vue?vue&type=template&id=36ab9435&scoped=true&"
import script from "./AccountBookForm.vue?vue&type=script&lang=js&"
export * from "./AccountBookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab9435",
  null
  
)

export default component.exports